/* eslint-disable indent,import/prefer-default-export */
import { buildModalQuery } from 'Consts/ModalQueries';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';

export const openTimeline = (calendarEventResource) => {
  openModal(
    buildModalQuery(modalConsts.timeline, {
      link: calendarEventResource
        .relationship('timeline')
        .link('related')
        .url(),
      date: calendarEventResource.attr('startTime'),
    }),
  );
};
